import { DynamicFormFieldValidator } from '../dynamic-form-element-validator.model';
import { DynamicFormElementValidatorConfig } from '../dynamic-form-element-validator-config.model';
import { DynamicFormElementValidatorType } from '../dynamic-form-element-validator-type.enum';
import { DateUtils } from '../../../utils/date.utils';
import { maxDate } from '../custom-validator-functions';

export class MinIntervalBeforeTodayValidator extends DynamicFormFieldValidator {

  defaultErrorMsg = 'La date ne doit pas être après le {{value}}';

  constructor(config: DynamicFormElementValidatorConfig) {
    super(config);
    this.setType(DynamicFormElementValidatorType.MIN_INTERVAL_BEFORE_TODAY);
    this.setValue(DateUtils.getDateFormatString(DateUtils.todayMinusDuration(DateUtils.intervalStringToDurationObject(config.value))));
    this.setDisplayValue(DateUtils.getDisplayString(DateUtils.todayMinusDuration(DateUtils.intervalStringToDurationObject(config.value))))
    this.configureError(config);
    this.setValidatorFn(maxDate(this.value));
  }

  configureError(config: DynamicFormElementValidatorConfig) {
    this.errorMsg = config.errorMsg ?? this.defaultErrorMsg;
    this.interpolateValueInErrorMessage(this.displayValue);
    this.errorKey = 'maxdate';
  }

}
